<template>
  <div>
    <div class="option_selection">
      <h6 class="prdt_sub_hdng">{{$t('noOfQuantity')}}</h6>
      <div class="quantity-toggle">
        <button @click="decrement()" :class="{'disabled' : isDisabledMinus}">&mdash;</button>
        <input type="text" :value="quantity" readonly />
        <button @click="increment()" :class="{'disabled' : isDisabledPlus}">&#xff0b;</button>
      </div>

      <div class="loader" v-if="loading">
        <img src="../../../assets/images/loader.gif" alt="loader" />
      </div>
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
  </div>
</template>

<script>
import CustomToaster from "../../Common/CustomToaster";
export default {
  name: "Quantity",
  components: {
    CustomToaster
  },
  props: {
    dataQuantity: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      quantity: 1,
      loading: false,
      toasterData: {},
      isToasterData: false,
      isDisabledMinus: false,
      isDisabledPlus: false
    };
  },
  watch: {
    dataQuantity() {
      this.details = this.dataQuantity;
      if (
      this.quantity == 1 &&
      this.details.maxOrderableQuantity > this.quantity
    ) {
      this.isDisabledMinus = true;
      this.isDisabledPlus = false;
    }
    if (Number(this.details.maxOrderableQuantity) === this.quantity) {
      this.isDisabledPlus = true;
      this.isDisabledMinus = true;
    }
    }
  },

  methods: {
    increment() {
      if (this.quantity === Number(this.details.maxOrderableQuantity)) {
        this.isDisabledPlus = true;
        this.isDisabledMinus = false;
      }
      if (this.details.maxOrderableQuantity > this.quantity) {
        this.quantity++;
        this.isDisabledMinus = false;
      }
       if (this.quantity === this.details.maxOrderableQuantity) {
          this.isDisabledPlus = true;
        }
      this.$emit("getItemQuantity", this.quantity);
    },
    decrement() {
      if (this.details.maxOrderableQuantity >= this.quantity) {
        this.isDisabledPlus = false;
      }
       if (this.quantity === 1) {
        this.isDisabledMinus = true;
        this.isDisabledPlus = true;
        return;
      } else {
        this.quantity--;
        if (this.quantity === 1) {
          this.isDisabledMinus = true;
        }
        this.$emit("getItemQuantity", this.quantity);
      }
    }
  },
  mounted() {
    this.details = this.dataQuantity;
    if (
      this.quantity == 1 &&
      this.details.maxOrderableQuantity > this.quantity
    ) {
      this.isDisabledMinus = true;
      this.isDisabledPlus = false;
    }
    if (Number(this.details.maxOrderableQuantity) === this.quantity) {
      this.isDisabledPlus = true;
      this.isDisabledMinus = true;
    }
  }
};
</script>
<style scoped>
.option_selection {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.quantity-toggle {
  display: flex;
  justify-content: center;
  width: 37%;
}
.quantity-toggle button,
.quantity-toggle input {
  border: 1px solid #ddd;
  text-align: center;
  padding: 5px 8px;
  color: #555;
  font-weight: 500;
  font-size: 0.938em;
}
.quantity-toggle button.disabled {
  opacity: 0.3;
  pointer-events: none;
}
</style>
